<template>
  <div class="bg-white border border-blue-100 flex items-center justify-between rounded-sm w-40">
    <w-button
      :disabled="count <= min"
      class="disabled:cursor-not-allowed flex-grow-0 flex-shrink-0 hover:text-blue-500 w-12"
      type="icon"
      @click="onMinusCount"
    >
      <i class="icon-minus" />
    </w-button>
    <w-input
      :max="max"
      :min="min"
      dense
      input-class="
        focus:border-b-primary-300
        hover:border-b-primary-300
        text-center
      "
      input-wrapper-class="w-fit"
      placeholder="0"
      shape="light"
      type="number"
      v-model="count"
      @blur="setIfEmptyValue"
      @keypress="filterOnlyNumberAndLengthSmallerThanMaxLength"
    />
    <w-button
      :disabled="count >= max"
      class="disabled:cursor-not-allowed flex-grow-0 flex-shrink-0 hover:text-blue-500 w-12"
      type="icon"
      @click="onAddCount"
    >
      <i class="icon-plus" />
    </w-button>
  </div>
</template>

<script>
import WCounter from './WCounter';

export default WCounter;
</script>

<style lang="scss" scoped>
@import 'WCounter';
</style>
